import React, { useRef, useState, useEffect } from 'react';

import Button from '../../../components/ui/Button';

const SignatureCanvas = ({ onSave, onClear }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);

  useEffect(() => {
    const canvas = canvasRef?.current;
    if (!canvas) return;

    const ctx = canvas?.getContext('2d');
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
  }, []);

  const startDrawing = (e) => {
    const canvas = canvasRef?.current;
    const rect = canvas?.getBoundingClientRect();
    const ctx = canvas?.getContext('2d');

    setIsDrawing(true);
    setHasSignature(true);

    const x = e?.clientX ? e?.clientX - rect?.left : e?.touches?.[0]?.clientX - rect?.left;
    const y = e?.clientY ? e?.clientY - rect?.top : e?.touches?.[0]?.clientY - rect?.top;

    ctx?.beginPath();
    ctx?.moveTo(x, y);
  };

  const draw = (e) => {
    if (!isDrawing) return;

    const canvas = canvasRef?.current;
    const rect = canvas?.getBoundingClientRect();
    const ctx = canvas?.getContext('2d');

    const x = e?.clientX ? e?.clientX - rect?.left : e?.touches?.[0]?.clientX - rect?.left;
    const y = e?.clientY ? e?.clientY - rect?.top : e?.touches?.[0]?.clientY - rect?.top;

    ctx?.lineTo(x, y);
    ctx?.stroke();
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef?.current;
    const ctx = canvas?.getContext('2d');
    ctx?.clearRect(0, 0, canvas?.width, canvas?.height);
    setHasSignature(false);
    onClear?.();
  };

  const saveSignature = () => {
    const canvas = canvasRef?.current;
    const signatureData = canvas?.toDataURL('image/png');
    onSave?.(signatureData);
  };

  return (
    <div className="space-y-3">
      <div className="border-2 border-dashed border-border rounded-lg overflow-hidden bg-white">
        <canvas
          ref={canvasRef}
          width={600}
          height={200}
          className="w-full cursor-crosshair touch-none"
          onMouseDown={startDrawing}
          onMouseMove={draw}
          onMouseUp={stopDrawing}
          onMouseLeave={stopDrawing}
          onTouchStart={startDrawing}
          onTouchMove={draw}
          onTouchEnd={stopDrawing}
        />
      </div>
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          iconName="Eraser"
          onClick={clearCanvas}
          disabled={!hasSignature}
        >
          Limpiar
        </Button>
        <Button
          type="button"
          variant="default"
          size="sm"
          iconName="Check"
          onClick={saveSignature}
          disabled={!hasSignature}
        >
          Guardar Firma
        </Button>
      </div>
    </div>
  );
};

export default SignatureCanvas;